// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"bffcd651","280":"7b985889","398":"b4a2e73f","425":"9c0db8d9","453":"6649d2f1","500":"a7691a64","817":"9429acd4"}[chunkId] + ".chunk.js";
};